import { AdminSideBar } from "../../../../modules/AdminSideBar";
import { AdminReceiptPdfGenerator } from "../../../../modules/PdfGenerator/PdfGenerator";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";

export const AdminOrder = () => {
  const navigate = useNavigate();
  const myUserType = useMemo(() => {
    const data = localStorage.getItem("auth-storage");
    return data ? JSON.parse(data).state?.user?.userType : null;
  }, []);

  useEffect(()=>{
    if(myUserType !== "admin"){
      alert("관리자 계정으로 로그인해주세요.")
      navigate("/admin")
    }
  }, [])

  // 관리자가 아니면 결제 상세 컴포넌트를 렌더하지 않는다.
  // useEffect는 렌더 이후 실행되므로, 이 조기 반환이 없으면 리다이렉트 전에
  // AdminReceiptPdfGenerator가 결제 상세 데이터를 조회·노출하게 된다.
  if (myUserType !== "admin") {
    return null;
  }

  return (
    <>
      <div className="admin-background">
        <div className="layout-flex">
          <AdminSideBar />
          <main className="admin-main-content">
            <h2 className="admin-page-title">결제정보</h2>
            <AdminReceiptPdfGenerator />
          </main>
        </div>
      </div>
    </>
  );
};
